// extracted by mini-css-extract-plugin
module.exports = {"copy":"main_copy__3J3W7","copy_success":"main_copy_success__2KzsP"};